import { useEffect, useRef, useState } from "react";

export default function useResizeObserver(elRef: React.RefObject<HTMLElement | null>, dependencies: any[] = []) {
  const [elRect, setElRect] = useState<DOMRectReadOnly>();
  const observerRef = useRef<ResizeObserver | undefined>(undefined);

  useEffect(() => {
    observerRef.current = new ResizeObserver((entries) => {
      window.requestAnimationFrame(() => {
        setElRect(entries[0].contentRect);
      });
    });
  }, []);

  useEffect(() => {
    const observer = observerRef.current;
    const element = elRef.current;

    if (observer && element) {
      // Get initial measurement synchronously to prevent undefined state
      // Use getBoundingClientRect() which is compatible with DOMRectReadOnly.
      // It returns precise CSS pixels including the fractional part, which is
      // important on displays with non-integer devicePixelRatio.
      const rect = element.getBoundingClientRect();
      setElRect(rect);

      observer.observe(element);

      return () => {
        observer.unobserve(element);
      };
    }
    return undefined;
  }, [elRef.current, observerRef.current, ...dependencies]);

  return elRect;
}
